var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-box"},[_c('el-dialog',{attrs:{"visible":_vm.addialogVisible,"close-on-click-modal":false,"destroy-on-close":true,"width":"60%","title":_vm.title,"before-close":_vm.close},on:{"update:visible":function($event){_vm.addialogVisible=$event}}},[_c('demand-detail',{attrs:{"id":_vm.row.id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }